module.exports = __webpack_public_path__ + "static/media/telephone.cd67b26e.svg";